document.addEventListener('DOMContentLoaded', function() {
    const zipCodeTB = document.getElementById('growingZone');
    const submitButton = document.getElementById('growingZoneBtn');
    const resultsContainer = document.querySelector('.header-box__growing-zone-num');
    const errorSpan = document.querySelector('.error');
    const noZoneText = document.querySelector('.header_box__no-growing-zone');
    const detailsContainer = document.createElement('div');
    resultsContainer.style.display = 'none';
    async function fetchZone(zip) {
        const response = await fetch(`https://phzmapi.org/${zip}.json`);
        if (!response.ok) throw new Error('Failed to fetch zone data');
        const zoneResults = await response.json();
        return zoneResults;
    }
    function showProducts(zoneNumber) {
        const allProductsGrids = document.querySelectorAll('.products-grid');
        allProductsGrids.forEach(grid => grid.style.display = 'none');
        const productsGrid = document.querySelector(`.products-zone-${zoneNumber}`);
        if (productsGrid) {
            productsGrid.style.display = 'flex';
        } else {
        }
    }
    submitButton.addEventListener('click', async (e) => {
        e.preventDefault();
        const zipCode = zipCodeTB.value.trim();
        const zipCodeRegex = /^\d{5}$/;
        if (zipCodeRegex.test(zipCode)) {
            try {
                const result = await fetchZone(zipCode);
                const zone = result.zone;
                const zoneNumberMatch = zone.match(/\d+/);
                const zoneNumber = zoneNumberMatch ? zoneNumberMatch[0] : '';
                if (!zoneNumber) throw new Error('Invalid zone number');
                resultsContainer.style.display = 'block';
                resultsContainer.innerText = `Growing Zone: ${zone}`;
                detailsContainer.innerHTML = `Temp Range: ${result.temperature_range}°F<br>`;
                resultsContainer.appendChild(detailsContainer);
                zipCodeTB.value = '';
                errorSpan.style.display = 'none';
                noZoneText.style.display = 'none';
                showProducts(zoneNumber);
                if (typeof Loox !== 'undefined' && Loox.reviewWidgets && Loox.reviewWidgets.refresh) {
                    Loox.reviewWidgets.refresh();
                }
            } catch (error) {
                resultsContainer.innerText = 'Failed to fetch data. Please try again later.';
                zipCodeTB.value = '';
            }
        } else {
            resultsContainer.innerText = '';
            errorSpan.style.display = 'block';
            zipCodeTB.value = '';
        }
    });
});